// extracted by mini-css-extract-plugin
export var button = "FixedSubscriptionPopup-module--button--ce95a";
export var close = "FixedSubscriptionPopup-module--close--45b43";
export var container = "FixedSubscriptionPopup-module--container--a6479";
export var errorMessage = "FixedSubscriptionPopup-module--errorMessage--7a933";
export var heading = "FixedSubscriptionPopup-module--heading--a8933";
export var left = "FixedSubscriptionPopup-module--left--beaa7";
export var right = "FixedSubscriptionPopup-module--right--c9629";
export var thankYou = "FixedSubscriptionPopup-module--thankYou--08963";